<template>
    <div class="center myCenter">
        <header class="mine-header">
            <div class="mine-header-inner">
                <img :src="require('../../../assets/img/personal/userHead.png')" class="mine-avatar" />
                <div class="mine-user-meta">
                    <div class="mine-name" v-if="userInfo.userNameNeedTranslate == '1'">
                        <TranslationOpenDataText type='userName' :openid='userInfo.name'></TranslationOpenDataText>
                    </div>
                    <div class="mine-name" v-else>{{userInfo.name}}{{ userInfo.roleName ? ' (' + userInfo.roleName + ')' : '' }}</div>
                    <div class="mine-company">
                        <van-icon name="shop-o" />
                        <span>{{ userInfo.companyName || '—' }}</span>
                    </div>
                </div>
            </div>
        </header>

        <main class="mine-body">
            <div class="stack-card">
                <div class="card-head">
                    <van-icon name="contact" class="card-head-icon" />
                    <span>账号信息</span>
                </div>
                <div class="info-row" v-if="userInfo.userNameNeedTranslate != '1'">
                    <div class="info-left">
                        <van-icon name="phone-o" class="row-icon phone" />
                        <span>手机号</span>
                    </div>
                    <span class="info-value">{{ userInfo.phone || '—' }}</span>
                </div>
                <div class="info-row">
                    <div class="info-left">
                        <van-icon name="shop-o" class="row-icon company" />
                        <span>所属公司</span>
                    </div>
                    <span class="info-value">{{ userInfo.companyName || '—' }}</span>
                </div>
                <div class="info-row" v-if="userInfo.jobNumber">
                    <div class="info-left">
                        <van-icon name="card" class="row-icon job" />
                        <span>工号</span>
                    </div>
                    <span class="info-value">{{ userInfo.jobNumber }}</span>
                </div>
                <div class="info-row">
                    <div class="info-left">
                        <van-icon name="award-o" class="row-icon version" />
                        <span>当前版本</span>
                    </div>
                    <span class="info-value">{{ version || '—' }}</span>
                </div>
                <div class="info-row last">
                    <div class="info-left">
                        <van-icon name="clock-o" class="row-icon expire" />
                        <span>有效期</span>
                    </div>
                    <span class="info-value expire-ok">{{ expirationDate || '—' }}</span>
                </div>
            </div>

            <div class="stack-card">
                <div class="card-head">
                    <van-icon name="shield-o" class="card-head-icon" />
                    <span>安全设置</span>
                </div>
                <div class="link-row" v-if="userInfo.userNameNeedTranslate != '1' && (isCorpWX || isWX)" @click="bindWeiXin">
                    <div class="info-left">
                        <van-icon name="wechat" class="row-icon wechat" />
                        <span>绑定{{ isCorpWX ? '企业' : '' }}微信</span>
                    </div>
                    <div class="link-right">
                        <span v-if="(isCorpWX && userInfo.corpwxUserid == null) || (isWX && userInfo.wxOpenid == null)" class="status-warn">未绑定</span>
                        <span v-else class="status-ok">已绑定</span>
                        <van-icon name="arrow" />
                    </div>
                </div>
                <div class="link-row" @click="instructions()">
                    <div class="info-left">
                        <van-icon name="description" class="row-icon doc" />
                        <span>使用说明</span>
                    </div>
                    <van-icon name="arrow" class="arrow" />
                </div>
                <div class="link-row" @click="tokefu()">
                    <div class="info-left">
                        <van-icon name="service-o" class="row-icon service" />
                        <span>在线客服</span>
                    </div>
                    <van-icon name="arrow" class="arrow" />
                </div>
                <div class="link-row" @click="addEmployee()" v-if="wxManager">
                    <div class="info-left">
                        <van-icon name="friends-o" class="row-icon friends" />
                        <span>添加员工</span>
                    </div>
                    <van-icon name="arrow" class="arrow" />
                </div>
                <div class="link-row last" @click="applicationMarket()">
                    <div class="info-left">
                        <van-icon name="apps-o" class="row-icon apps" />
                        <span>应用市场</span>
                    </div>
                    <div class="link-right">
                        <span class="link-hint">发现更多应用</span>
                        <van-icon name="arrow" />
                    </div>
                </div>
            </div>

            <van-button class="logout" @click="logout" block round plain hairline type="danger" v-if="!isCorpWX">
                <van-icon name="revoke" /> 退出登录
            </van-button>

            <van-button class="logout" @click="unbindCorpWX" block round plain hairline type="danger" v-if="isCorpWX && userInfo.corpwxUserid != null && userInfo.userNameNeedTranslate != '1'">
                <van-icon name="revoke" /> 解除绑定
            </van-button>

            <div class="mine-footer-ver">工时管家 · {{ version || 'v1.0.0' }}</div>
        </main>

        <Footer page="my" />
    </div>
</template>

<script>
    import Footer from "@/components/Footer";
    import { mapGetters } from "vuex";
    export default {
        components: {
            Footer
        },

        computed: {
            ...mapGetters(["userId", "isLogin"])
        },

        data() {
            return {
                userInfo: JSON.parse(localStorage.userInfo),
                isCorpWX:false,
                isWX:false,
                expirationDate: '', // 有效日期
                version: '', // 版本
                show: false,
                
                wxManager: false,
            }
        },

        methods: {
            applicationMarket() {
                window.location.href = 'https://www.ttkuaiban.com/appMarket.html'
            },
            logout() {
                this.$store.commit("updateLogin", false);
                localStorage.removeItem("userInfo");
                this.$router.push("/login");
            },
            unbindCorpWX() {
                this.$dialog.confirm({
                    title: '',
                    message: '解除绑定后只能通过账号密码登录，您确定吗？'
                }).then(() => {
                    this.$axios.post("/user/unbindCorpWX", {userId: this.userInfo.id})
                    .then(res => {
                        if(res.code == "ok") {
                            this.$store.commit("updateLogin", false);
                            localStorage.removeItem("userInfo");
                            this.$router.push("/login");
                        } else {
                            this.$toast.clear();
                            this.$toast.fail(res.msg);
                        }
                    }).catch(err=> {this.$toast.clear();});
                }).catch(() => {
                });
            },
            bindWeiXin(){
                //企业微信
                if (this.isCorpWX && this.userInfo.corpwxUserid != null) {
                    return;
                }
                //微信
                else if (this.isWX && this.userInfo.wxOpenid != null) {
                    return;
                }
                var appId = "wx749c84daac654e1e";//工时管家公众号
                var url = "http://mobworktime.ttkuaiban.com/api/wechat/bindWeiXin2?userId="+this.userInfo.id;//工时管家公众号授权回调页面
                if (this.isCorpWX) {
                    appId = "ww4e237fd6abb635af"; //企业微信第三方的SUIT ID
                    url = "http://worktime.ttkuaiban.com/api/wxcorp/bindCorpWeiXin?userId="+this.userInfo.id;//授权回调页面
                } 

                var weixinUrl="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+appId+"&redirect_uri="+encodeURI(url)+"&response_type=code&scope=snsapi_base&state=0#wechat_redirect";
                window.location.href = weixinUrl;
            },
            // 使用说明
            instructions() {
                let url = 'http://celiang.oss-cn-hangzhou.aliyuncs.com/measurement/2022-01/18/75it6phpocqYFV1642488558220118.pdf'
                let name = '使用说明书'
                this.previewPDF(url, name)
            },
            // 预览pdf
            previewPDF(url, name) {
                this.$router.push({
                    path:  '/pdf',
                    query: {
                        url: '',
                        name: name
                    }
                })
            },
            // 添加员工
            addEmployee() {
                wx.invoke('openAppManage', {}, function(res){
                    console.log(res, '你在看看')
                    if(res.err_msg == "openAppManage:ok") {
                        // 调用成功              
                    }
                    if(res.err_msg == "openAppManage:fail:no permission") {
                        // 调用人身份不符合                 
                        this.$message({message: '调用人身份不符合',type: "error"});
                    }
                    if(res.err_msg == "openAppManage:fail:unknown app") {
                        // 应用信息获取失败
                        this.$message({message: '应用信息获取失败',type: "error"});
                    }
                    if(res.err_msg == "openAppManage:fail:unsupported app type") {
                        // 应用类型不符合要求
                        this.$message({message: '应用类型不符合要求',type: "error"});
                    }
                    if(res.err_msg == "openAppManage:fail") {
                        // 其它错误                  
                        this.$message({message: '其它错误',type: "error"});
                    }      
                })
            },
            // 跳转客服
            tokefu(){
                wx.invoke('openThirdAppServiceChat', {
                    }, function(res) {
                        console.log('invoke',res);
                        if (res.err_msg == "openThirdAppServiceChat:ok" || res.err_msg == "openThirdAppServiceChat:cancel") {
                        }else{
                            this.$toast.fail('请联系管理员添加客服');
                        }
                        
                    }
                );
            },
            // 判断是否有添加员工的权限
            getWxManager() {
                this.$axios.post("/user/isManager", {})
                .then(res => {
                    if(res.code == "ok") {
                        let bur = res.data + ''
                        this.wxManager = bur == 'true'
                    } else {
                        this.$toast.clear();
                        this.$toast.fail(res.msg);
                    }
                }).catch(err=> {this.$toast.clear();});
            }
        },
        create() {
        },
        mounted() {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf("wxwork") > 0) {
                this.isCorpWX = true;
            } else if (ua.indexOf("micromessenger") > 0) {
                this.isWX = true;
            }
            
            // 拼接有效日期 和 版本
            if(localStorage.userInfo) {
                // 日期
                let userss = JSON.parse(localStorage.userInfo)
                this.expirationDate = userss.company.expirationDate[0] + '-' + 
                (userss.company.expirationDate[1] >= 10 ? userss.company.expirationDate[1] : ('0' + userss.company.expirationDate[1]))
                 + '-' + (userss.company.expirationDate[2] >= 10 ? userss.company.expirationDate[2] : ('0' + userss.company.expirationDate[2]))

                // 版本
                userss.company.packageWorktime == 1 ? this.version = '基础版' : ''
                userss.company.packageProject == 1 ? this.version = '专业版' : ''
                userss.company.packageEngineering == 1 ? this.version = '建筑工程版' : ''
                userss.company.packageOa == 1 ? this.version = '旗舰版' : ''

                console.log(this.version)
            }

            this.getWxManager()
        }
    };
</script>

<style lang="less" scoped>
    .myCenter {
        min-height: 100vh;
        background: #f2f4f7;
        padding-bottom: 70px;
        box-sizing: border-box;
    }
    .mine-header {
        background: linear-gradient(180deg, #2b7cff 0%, #4a9bff 100%);
        padding: 48px 20px 54px;
        position: relative;
        z-index: 1;
    }
    .mine-header-inner {
        display: flex;
        align-items: center;
    }
    .mine-avatar {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        border: 2px solid rgba(255,255,255,0.85);
        background: #fff;
        flex-shrink: 0;
    }
    .mine-user-meta {
        margin-left: 14px;
        min-width: 0;
        color: #fff;
    }
    .mine-name {
        font-size: 18px;
        font-weight: 600;
        line-height: 1.3;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .mine-company {
        margin-top: 6px;
        font-size: 12px;
        opacity: 0.92;
        display: flex;
        align-items: center;
        .van-icon {
            margin-right: 4px;
            font-size: 13px;
        }
        span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .mine-body {
        margin-top: -28px;
        padding: 0 14px 12px;
        position: relative;
        z-index: 2;
    }
    .stack-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 6px 18px rgba(43, 124, 255, 0.08);
        margin-bottom: 12px;
        overflow: hidden;
        padding: 0 14px;
    }
    .card-head {
        display: flex;
        align-items: center;
        padding: 14px 0;
        font-size: 15px;
        font-weight: 600;
        color: #222;
        border-bottom: 1px solid #f0f2f5;
    }
    .card-head-icon {
        color: #2b7cff;
        font-size: 18px;
        margin-right: 6px;
    }
    .info-row,
    .link-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 48px;
        border-bottom: 1px solid #f0f2f5;
        font-size: 14px;
        color: #333;
    }
    .info-row.last,
    .link-row.last {
        border-bottom: none;
    }
    .info-left {
        display: flex;
        align-items: center;
        min-width: 0;
    }
    .row-icon {
        margin-right: 8px;
        font-size: 16px;
        &.phone { color: #2b7cff; }
        &.company { color: #36cfc9; }
        &.job { color: #722ed1; }
        &.version { color: #fa8c16; }
        &.expire { color: #52c41a; }
        &.wechat { color: #07c160; }
        &.doc { color: #2b7cff; }
        &.service { color: #13c2c2; }
        &.friends { color: #597ef7; }
        &.apps { color: #eb2f96; }
    }
    .info-value {
        color: #666;
        max-width: 58%;
        text-align: right;
        word-break: break-all;
    }
    .expire-ok {
        color: #52c41a;
        font-weight: 500;
    }
    .link-right {
        display: flex;
        align-items: center;
        color: #99a1ad;
        .van-icon {
            margin-left: 4px;
        }
    }
    .link-hint {
        font-size: 12px;
        color: #99a1ad;
    }
    .status-warn { color: #ff4d4f; font-size: 13px; }
    .status-ok { color: #52c41a; font-size: 13px; }
    .arrow { color: #c0c4cc; }
    .logout {
        width: 86%;
        margin: 18px auto 8px;
        border-color: #ff7875 !important;
        color: #ff4d4f !important;
        height: 44px;
        .van-icon {
            margin-right: 4px;
            vertical-align: -1px;
        }
    }
    .mine-footer-ver {
        text-align: center;
        color: #b0b6c0;
        font-size: 12px;
        padding: 8px 0 16px;
    }
</style>
